import React, { useEffect } from 'react';
import Merchant from '../../../components/Merchant/Merchant';
import { getUserMerchants } from "../../../redux/actions/adminPanel/adminUsers";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import ReactPaginate from 'react-paginate';
import './styles.scss';
import WalletCreateModal from "../../../components/WalletCreateModal/WalletCreateModal";
import PageHeader from "../../../layout/PageHeader";

const UserAccounts = ({ getUserMerchants, userMerchants, page, pages, userMerchantsFetching }) => {
  const { userId } = useParams();

  console.log(userId);

  const handlePageClick = (selectedPage) => {
    const pageNumber = selectedPage.selected + 1;

    getUserMerchants(userId, 10, pageNumber);
  };

  useEffect(() => {
    if (userId) {
      getUserMerchants(userId, 10, 1);
    }
  }, [userId]);

  const WalletCreateComponent = () => (
    <WalletCreateModal
      typeWallet="merchant"
      filtersFormName="merchantWalletsFilters"
    />
  );

  return (
    <div className="admin-accounts">
      {userMerchants?.length ? (
        <PageHeader merchants={true} showCreate={false} showBackButton={true} CreateModalComponent={WalletCreateComponent} />
      ) : null}
      {userMerchants?.length && userMerchants?.map((item) => (
        <Merchant type="admin" merchant={item} userRole="corporate" />
      ))}
      {pages > 1 && (
        <ReactPaginate
          pageCount={pages}
          pageRangeDisplayed={5}
          marginPagesDisplayed={2}
          onPageChange={handlePageClick}
          containerClassName="pagination"
          activeClassName="active"
          previousLabel={"«"}
          nextLabel={"»"}
          breakLabel={"..."}
          forcePage={page - 1}
        />
      )}
    </div>
  )
};

const mapStateToProps = state => ({
  userMerchants: state.adminUsers.userMerchants.data,
  page: state.adminUsers.userMerchants.page,
  pages: state.adminUsers.userMerchants.pages,
  userMerchantsFetching: state.adminUsers.userMerchants.fetching,
});

const mapDispatchToProps = {
  getUserMerchants,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAccounts);